import { render, staticRenderFns } from "./SavedAnchorPage.vue?vue&type=template&id=b8498b9c&scoped=true"
import script from "./SavedAnchorPage.vue?vue&type=script&lang=js"
export * from "./SavedAnchorPage.vue?vue&type=script&lang=js"
import style0 from "./SavedAnchorPage.vue?vue&type=style&index=0&id=b8498b9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8498b9c",
  null
  
)

export default component.exports